<template>
  <div class="homecontainer">

    <div :class="type==7? 'contactstitle' :'bottomtitle'" id="home_title">
<!--Products.vue顶部的跳转-->
        <div class="titledivJump">
          <div v-for="item in titleJump" @click="routerpush(item.router)">{{$i18n.locale=='zh_HK'?item.title:item.titleEn}}</div>
        </div>
        <p class="wow fadeInUp" v-html="titlename">{{titlename}}</p>
        <span class="wow fadeInUp" v-html="textContent" v-show="textContent!=null">{{textContent}} </span>
<!--      </div>-->
    </div>
    <img :src="imgsrc">

  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "MainTop",
    props: ['titlename', 'textContent', 'imgsrc', 'type', 'titleJump'],
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    methods: {
      routerpush(to) {
        this.$router.push(to)
      },
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .homecontainer {
      margin-top: -5%;
      position: relative;
      width: 100%;
      /*height: 1000px;*/
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      min-height: 500px;
      font-size: 1em;
      overflow: hidden;
      .contactstitle{
        top: -10%;
      }
      .bottomtitle{
        top: 10%;
      }
      #home_title {
        position: absolute;
        /*top: 10%;*/
        left: 50%;
        width:90%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px 0;
        font-size: 2em;
        z-index: 999;
        color: white;

        .titledivJump {
          width: 100%;
          display: flex;
          text-align: center;

          div {
            width: 100%;
            font-size: 0.6em;
            font-weight: bold;
            /*background-color:#2FA8DB;*/
            /*border:1px solid #200A42;*/
            padding: 2% 0;
            transition: all 0.2s; //设置动画执行的时间为0.6s
            cursor: pointer;
          }
          div:hover{
            transform: scale(1.05);
          }
        }

        h1 {
          font-size: 1.2em;
        }

        p {
          padding-top: 18%;
          font-size: 1.4em;
          font-weight: 600;
        }

        span {
          width: 80%;
          margin-top: 7.5%;
          font-size: 1.2em;
        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .homecontainer {
      margin-top: -5%;
      position: relative;
      width: 100%;
      /*height: 1000px;*/
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      font-size: 1em;

      .contactstitle{
        top: -10%;
      }
      .bottomtitle{
        top: 10%;
      }
      #home_title {
        position: absolute;
        /*top: 10%;*/
        left: 50%;
        width: 90%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px 0;

        font-size: 2em;
        z-index: 999;
        color: white;

        .titledivJump {
          width: 100%;
          display: flex;

          div {
            width: 100%;
            font-size: 0.8em;
            font-weight: bold;
            /*background-color:#2FA8DB;*/
            /*text-align: center;*/
            padding: 2% 0;
          }
        }

        h1 {
          font-size: 1.2em;

        }

        p {

          padding-top: 16%;
          font-size: 1.4em;
          font-weight: 700;
        }

        span {
          width: 80%;
          margin-top: 7.5%;
          font-size: 1.2em;

        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/comcomponents/MainTop.vue